import { ticketTypes } from './ticketTypes'

const INITIAL_STATE = {
    allTickets: [],
    meta: '',
    loading: false,
    crudLoading: false,
    changeStatus: false,
}

const ticketReducer = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        // ------------------ get all tickets ----------------
        case ticketTypes.GET_ALL_TICKETS_START:
            return {
                ...state,
                loading: true,
            }
        case ticketTypes.GET_ALL_TICKETS_SUCCESS:
            return {
                ...state,
                allTickets: actions.payload,
                meta: actions.meta,
            }
        case ticketTypes.GET_ALL_TICKETS_FAILED:
            return {
                ...state,
                loading: false,
            }
        case ticketTypes.GET_ALL_TICKETS_END:
            return {
                ...state,
                loading: false,
            }
        // -------------------- create a ticket -----------
        case ticketTypes.CREATE_A_TICKET_START:
            return {
                ...state,
                crudLoading: true,
            }
        case ticketTypes.CREATE_A_TICKET_SUCCESS:
            return {
                ...state,
                allTickets: actions.payload,
            }
        case ticketTypes.CREATE_A_TICKET_FAILED:
            return {
                ...state,
                crudLoading: false,
                allTickets: actions.payload,
            }
        case ticketTypes.CREATE_A_TICKET_END:
            return {
                ...state,
                crudLoading: false,
            }
        // -------------------- add message to ticket -----------
        case ticketTypes.ADD_MESSAGE_TO_TICKET_START:
            return {
                ...state,
                crudLoading: true,
            }
        case ticketTypes.ADD_MESSAGE_TO_TICKET_SUCCESS:
            return {
                ...state,
                allTickets: actions.payload,
            }
        case ticketTypes.ADD_MESSAGE_TO_TICKET_FAILED:
            return {
                ...state,
                crudLoading: false,
                allTickets: actions.payload,
            }
        case ticketTypes.ADD_MESSAGE_TO_TICKET_END:
            return {
                ...state,
                crudLoading: false,
            }
        // ------------------ update a ticket ---------------
        case ticketTypes.UPDATE_TICKET_START:
            return {
                ...state,
                changeStatus: true,
            }
        case ticketTypes.UPDATE_TICKET_SUCCESS:
            return {
                ...state,
                allTickets: actions.payload,
            }
        case ticketTypes.UPDATE_TICKET_FAILED:
            return {
                ...state,
                allTickets: actions.payload,
            }
        case ticketTypes.UPDATE_TICKET_END:
            return {
                ...state,
                changeStatus: false,
            }
        default:
            return state
    }
}

export default ticketReducer
